import request from "./request";
// 资产
// 转化管理列表
export const getGoogleConversionList = (data) => request("/google/conversion/list", data, "POST_JSON");
// 修改显示状态
export const updateGoogleConversionStatus = (data) => request("/google/conversion/update", data, "POST_JSON");
// 地区组,标题包,描述包,创意组
export const getAssetGroupList = (data) => request("/assetGroup/list", data, "POST_JSON");
// 删除地区组,标题包,描述包,创意组
export const deleteAssetGroup = (data) => request("/assetGroup/delete", data, "POST");
// 保存地区组,标题包,描述包,创意组
export const saveAssetGroup = (data) => request("/assetGroup/save", data, "POST_JSON");
// 产品列表(通用)
export const getCommonProductList = (data) => request("/adCommon/product/list", data, "GET");
// 转化管理数据同步
export const syncGoogleConversion = (data) => request("/google/conversion/sync", data, "GET");

// 广告账户管理
// 账户授权解绑
export const unBindGoogleAccount = (data) => request("/google/account/unBind", data, "POST_JSON");
// 谷歌认证url
export const getGoogleAccountAuthurl = (data) => request("/google/account/authUrl", data, "GET");
// mcc筛选列表
export const getGoogleAccountManagerList = (data) => request("/google/account/managerList", data, "GET");
// 广告主授权列表
export const getGoogleAccountList = (data) => request("/google/account/accountList", data, "GET");
// 账户授权绑定
export const bindGoogleAccount = (data) => request("/google/account/bind", data, "POST_JSON");
// 媒体账户列表
export const getMediaAccountList = (data) => request("/mediaAccount/list", data, "GET");
// 删除媒体账户
export const deleteMediaAccount = (data) => request("/mediaAccount/deleteById", data, "GET");
// 修改同步状态
export const updateMediaAccountStatus = (data) => request("/mediaAccount/updateStatus", data, "POST_JSON");
// 媒体账户-授权人列表
export const getMediaAuthUsers = (data) => request("/mediaAccount/authUsers", data, "GET");

// 创建广告
// 应用列表
export const getGoogleAppList = (data) => request("/google/app/list", data, "GET");
// 转化管理列表
export const getGoogleConversions = (data) => request("/google/conversions", data, "POST_JSON");
// 创建应用
export const createGoogleApp = (data) => request("/google/app/create", data, "POST");
// 广告计划列表(通用)
export const getAdCampaignList = (data) => request("/adCommon/campaign/list", data, "GET");
// 广告系列数据同步
export const refreshGoogleCampaginList = (data) => request("/google/campaign/sync", data, "GET");
// 广告系列数据同步
export const getAdCampaignDetail = (data) => request("/google/campaign/details", data, "GET");
// 语言列表
export const getGoogleLanguageList = (data) => request("/google/language/list", data, "GET");
// 地区列表
export const getGoogleGeoList = (data) => request("/google/geo/list", data, "GET");
// 地区导入
export const importGoogleGeo = (data) => request("/google/geo/import", data, "POST_JSON");
// 提交预览
export const previewGoogle = (data) => request("/google/preview", data, "POST_JSON");
// 预览列表
export const getGooglePreviewList = (data) => request("/google/preview/list", data, "GET");
// 发布
export const publishGoogle = (data) => request("/google/publish", data, "GET");
// 预览列表-修改状态
export const updateAdStatus = (data) => request("/adCommon/preview/updateStatus", data, "POST_JSON");
// 保存草稿
export const saveAdCommonDraft = (data) => request("/adCommon/draft/save", data, "POST_JSON");
// 草稿详情
export const getAdCommonDraftDetail = (data) => request("/adCommon/draft/details", data, "GET");
// 删除草稿
export const deleteAdCommonDraft = (data) => request("/adCommon/draft/delete", data, "GET");

// 推广报表
// 投放账号报表
export const getGoogleAdvertiserReport = (data) => request("/google/report/advertiser", data, "POST_JSON");
// 广告系列报表
export const getGoogleCampaignReport = (data) => request("/google/report/campaign", data, "POST_JSON");
// 广告组报表
export const getGoogleAdgroupReport = (data) => request("/google/report/adgroup", data, "POST_JSON");
// 素材资源报表
export const getGoogleAdMaterialReport = (data) => request("/google/report/material", data, "POST_JSON");
// 广告组筛选列表
export const getAdCommonAdGroupList = (data) => request("/adCommon/adGroup/list", data, "GET");
// 修改广告组状态
export const updateGoogleAdGroupStatus = (data) => request("/google/adGroupStatus", data, "POST_JSON");
// 修改广告系列状态
export const updateGoogleCampaignStatus = (data) => request("/google/campaignStatus", data, "POST_JSON");
// 同步广告账号报表
export const refreshGoogleAdvertiser = (data) => request("/google/report/syncAdvertiser", data, "POST_JSON");
